export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11586.ec9bd786.jpg";